import React from 'react';
import classNames from 'clsx';
import { twMerge } from 'tailwind-merge';
import { getButtonClasses } from './ButtonClasses';
import type { ButtonColor, ButtonShape, ButtonSize, ButtonVariant } from './button-config';

export type ButtonBaseProps = React.ComponentPropsWithRef<'button'> & {
  color: ButtonColor;
  disabled?: boolean;
  fullWidth?: boolean;
  shape?: ButtonShape;
  size: ButtonSize;
  variant: ButtonVariant;
};

export const ButtonBase = React.forwardRef<HTMLButtonElement, ButtonBaseProps>(
  (
    {
      color,
      disabled = false,
      fullWidth = false,
      shape = 'standard',
      size,
      type = 'button',
      variant,

      ...props
    },
    ref
  ) => {
    const { buttonClasses } = getButtonClasses({
      color,
      disabled,
      fullWidth,
      shape,
      size,
      variant,
    });

    return (
      <button
        {...props}
        type={type}
        ref={ref}
        disabled={disabled}
        className={twMerge(classNames(buttonClasses, props.className))}
      >
        {props.children}
      </button>
    );
  }
);

ButtonBase.displayName = 'ButtonBase';
